<template>
  <div>
    <template v-if="!isMobile">
      <el-tabs
        v-model="activeDate"
        class="custom-date-tabs"
        @tab-click="handleTabClick"
      >
        <el-tab-pane
          v-for="(dateItem, index) in formattedDateList"
          :key="index"
          :name="dateItem.fullDate"
        >
          <template #label>
            <div
              :class="[
                'tab-label',
                activeDate == dateItem.fullDate ? 'is-active' : '',
              ]"
            >
              <div class="date">{{ dateItem.date }}</div>
              <div class="week">{{ dateItem.weekday }}</div>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template v-else>
      <el-tabs
        v-model="activeDate"
        class="custom-date-tabs2"
        @tab-click="handleTabClick"
      >
        <el-tab-pane
          v-for="(dateItem, index) in formattedDateList"
          :key="index"
          :name="dateItem.fullDate"
        >
          <template #label>
            <div
              :class="[
                'tab-label2',
                activeDate == dateItem.fullDate ? 'is-active' : '',
              ]"
            >
              <div class="date2">{{ dateItem.date }}</div>
              <div class="week2">{{ dateItem.weekday }}</div>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>
</template>

<script>
import responsiveMixin from '@/mixins/responsiveMixin';
export default {
  mixins: [responsiveMixin],
  props: {
    dateList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeDate: this.value, // 默认选中第一个
    };
  },
  computed: {
    formattedDateList() {
      return this.dateList.map((date) => {
        const d = new Date(date.date);
        return {
          fullDate: date.date,
          date: this.formatDate(d),
          weekday: this.getWeekday(d),
        };
      });
    },
  },

  methods: {
    formatDate(date) {
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${month}-${day}`;
    },
    getWeekday(date) {
      const weekdays =
        this.$i18n.locale == 'en'
          ? [
              this.$t('sunday'),
              this.$t('monday'),
              this.$t('tuesday'),
              this.$t('wednesday'),
              this.$t('thursday'),
              this.$t('friday'),
              this.$t('saturday'),
            ]
          : ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

      return weekdays[date.getDay()];
    },
    handleTabClick(tab) {
      this.$emit('change', tab.name);
    },
  },
  watch: {
    value(newVal) {
      this.activeDate = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-date-tabs {
  width: 100%;
  overflow: visible; /* 关键设置 */
  position: relative;
  .tab-label {
    border: solid 1px #d9d9d9;
    border-radius: 0.625rem;
    padding: 1.25rem 2rem;
    cursor: pointer;
    min-height: 8.125rem;

    .date {
      color: #424451;
      font-size: 2rem;
      font-family: SourceHanSansCN-Medium;
    }
    .week {
      color: #aaaaaa;
      font-size: 1.75rem;
      text-align: center;
      max-width: 5.625rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .tab-label2 {
    border: solid 1px #d9d9d9;
    border-radius: 0.625rem;
    padding: 0.625rem;
    cursor: pointer;
    min-height: 4.1667rem !important;

    .date2 {
      color: #424451;
      font-size: 1.25rem;
      height: 1.8333rem;
    }
    .week2 {
      color: #aaaaaa;
      font-size: 1.0833rem;
      font-family: SourceHanSansCN-Medium;
      text-align: center;
      height: 2.5rem;
    }
  }

  ::v-deep {
    .el-tabs__header {
      margin: 0;
    }

    .el-tabs__nav {
      height: 8.5rem !important;
    }
    .el-tabs__nav-wrap::after {
      height: 0px;
    }
    .el-tabs__active-bar {
      height: 0px;
    }
    .tab-label:hover,
    .tab-label.is-active {
      background: #424451;
      color: #fff;
      border: solid 1px #424451;
      .date {
        color: #fff;
      }
      .week {
        color: #fff;
        font-size: 1.75rem;
      }
    }
    .tab-label.is-active .weekday {
      color: rgba(255, 255, 255, 0.7);
    }

    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      font-size: 2.625rem;
      height: 8.2rem !important;
      width: 3rem;
      z-index: 9999;
      background: #c2c2c2;
      overflow: hidden;
      color: #fff;
    }
    .el-tabs__nav-next {
      box-shadow: -6px 0px 10px 0px rgba(0, 0, 0, 0.08) !important;
    }
    .el-tabs__nav-prev {
      box-shadow: 6px 0px 10px 0px rgba(0, 0, 0, 0.08) !important;
    }
    .el-icon-arrow-left,
    .el-icon-arrow-right {
      margin-top: 100%;
    }
  }
}
.custom-date-tabs2 {
  .tab-label2 {
    border: solid 1px #d9d9d9;
    border-radius: 0.625rem;
    padding: 0.625rem;
    cursor: pointer;
    min-height: 4.1667rem !important;

    .date2 {
      color: #424451;
      font-size: 1.25rem;
      height: 1.8333rem;
    }
    .week2 {
      color: #aaaaaa;
      font-size: 1.0833rem;
      font-family: SourceHanSansCN-Medium;
      text-align: center;
      height: 2.5rem;
    }
  }
  ::v-deep {
    .el-tabs__header {
      margin: 0;
    }
    .el-tabs__item {
      padding: 0 0.8333rem;
    }
    .el-tabs__nav {
      height: 7rem !important;
    }
    .el-tabs__nav-wrap::after {
      height: 0px;
    }
    .el-tabs__active-bar {
      height: 0px;
    }
    .tab-label2:hover,
    .tab-label2.is-active {
      background: #424451;
      color: #fff;
      border: solid 1px #424451;
      .date2 {
        color: #fff;
      }
      .week2 {
        color: #fff;
      }
    }
    .tab-label2.is-active .weekday {
      color: rgba(255, 255, 255, 0.7);
    }

    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      font-size: 1.6667rem;
      height: 5.7rem !important;
      width: 2rem;
      z-index: 6;
      background: #c2c2c2;
      overflow: hidden;
      color: #fff;
    }
    .el-tabs__nav-next {
      box-shadow: -6px 0px 10px 0px rgba(0, 0, 0, 0.08) !important;
    }
    .el-tabs__nav-prev {
      box-shadow: 6px 0px 10px 0px rgba(0, 0, 0, 0.08) !important;
    }
    .el-icon-arrow-left,
    .el-icon-arrow-right {
      margin-top: 100%;
    }
  }
}
</style>
